import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import './InfoPage.css';

const SupportPage = () => {
  const navigate = useNavigate();
  return (
    <div className="info-page">
      <div className="info-header-wrap"><Header /></div>
      <div className="info-container">
        <button className="back-btn" onClick={() => navigate('/')}>← Back</button>
        <h1>Support</h1>
        <p>Get help with bookings, payments, or account issues.</p>
        <ul>
          <li>FAQ coming soon</li>
          <li>Live chat (in development)</li>
          <li>Email support: support@myhelpz.com</li>
        </ul>
      </div>
      <Footer />
    </div>
  );
};

export default SupportPage;
